import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React from "react";
import { deleteFaqApi } from "services/faq";
import { deleteFeedbackApi } from "services/feedback";
import { toastMessage } from "utils/toastMessage";

const Delete = ({
  deleteModal,
  selectedFaqDetail,
  setFaqList,
  closeModel,
}) => {
  const [faqButtonLoader, setFaqButtonLoader] = useButtonLoader("Yes");

  const deleteFaqHandler = async () => {
    try {
      setFaqButtonLoader(true);
      const { data: responseData, status } = await deleteFeedbackApi(
        { _id: selectedFaqDetail._id }
      );
      if (status === 200) {
        // Remove the deleted category from the list
        setFaqList((prevList) =>
          prevList.filter((faq) => faq._id !== selectedFaqDetail._id)
        );
        closeModel();
        toastMessage(responseData.message, "success", "deleteFaq");
      }
    } catch (e) {
      console.log("error:", e);
    } finally {
      setFaqButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this feedback?"
        title="Delete Feedback"
        buttonLoader={faqButtonLoader}
        action={deleteFaqHandler}
      />
    </>
  );
};

export default Delete;
